module.exports = __webpack_public_path__ + "static/agreement-4a0459d78953611879bf3eac2370ddcd.jpg";